import React from "react";

import MenuLatest from "./MenuLatest";

import ViewerStyle from '../../css/Viewer.module.css'
import logo from '../../images/logo-cnc.png';

export default function Menu(props) {

    const { viewersLatest, viewersModelo1, viewersModelo0, viewersUniversoClaro, viewersCincoMinutos, othersViewers, changeViewer, location, dataViewers, menuOpenings } = props;

    const hideMenu = () => {
        const menu = document.getElementById('menu-container')
        menu.classList.remove(ViewerStyle["menu-transition"])

        const modal = document.getElementById('modal-menu')
        setTimeout(function () {
            modal.classList.replace(ViewerStyle["show-modal-menu"], ViewerStyle["hide-modal-menu"])
        }, 400);
    }

    return (
        <>
            <div className={ViewerStyle["modal-menu"]} id="modal-menu">
                <div className={ViewerStyle["layer-hide-menu"]} onClick={() => hideMenu()}></div>
                <div className={ViewerStyle["menu-container"]} id="menu-container">
                    <div className={ViewerStyle["menu-header"]}>
                        <button title="Cerrar Menú" onClick={() => hideMenu()} className={ViewerStyle["btn-menu"]}>
                            <ion-icon className={ViewerStyle["menu-icon"]} name="menu-outline" />
                        </button>
                        <a href="https://www.centronacionaldeconsultoria.com/" target="_blank" rel="noreferrer">
                            <img className={ViewerStyle["menu-logo"]} src={logo} alt="Centro Nacional de Consultoría" />
                        </a>
                    </div>
                    <MenuLatest
                        viewersLatest={viewersLatest}
                        viewersModelo1={viewersModelo1}
                        viewersModelo0={viewersModelo0}
                        viewersUniversoClaro={viewersUniversoClaro}
                        viewersCincoMinutos={viewersCincoMinutos}
                        othersViewers={othersViewers}
                        changeViewer={changeViewer}
                        location={location}
                        dataViewers={dataViewers}
                        menuOpenings={menuOpenings}
                    />
                </div>
            </div>
        </>
    )

}